import { render, staticRenderFns } from "./NewComposerTextArea.vue?vue&type=template&id=7877857c&"
import script from "./NewComposerTextArea.vue?vue&type=script&lang=js&"
export * from "./NewComposerTextArea.vue?vue&type=script&lang=js&"
import style0 from "./NewComposerTextArea.vue?vue&type=style&index=0&id=7877857c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports